import { FC } from 'react';
import dynamic from 'next/dynamic';

import { SimpleVideoSpotProps } from 'composables/Product/SimpleVideoSpot/SimpleVideoSpotComposable';

const SimpleVideoSpotComposable = dynamic(
  () => import('composables/Product/SimpleVideoSpot/SimpleVideoSpotComposable'),
  {
    loading: () => (
      <div className="flex aspect-video animate-pulse items-center justify-center bg-gray-200">
        <div className="text-gray-500">Loading video component...</div>
      </div>
    ),
  }
);

const CaseStudyVideoComponent: FC<SimpleVideoSpotProps> = (props) => {
  return <SimpleVideoSpotComposable {...props} />;
};

export default CaseStudyVideoComponent;
